/* S7 CRO — live "Spend $100, get 25% off" cart nudge updater.
   Loaded document-level from layout/theme.liquid so it ALWAYS executes.
   The cart drawer is template-cloned / innerHTML-injected by the theme, so a
   <script> placed inside the drawer snippet never runs — hence this lives here.

   IMPORTANT: the "25% off min $100" discount is PRODUCT-SCOPED. Shopify measures
   the $100 minimum against the ELIGIBLE products' subtotal (verified 2026-06-27),
   not the whole cart. So the bar tracks the eligible subtotal only — it shows
   when the cart has eligible merchandise under $100, hides at $0 eligible and
   once eligible >= $100. Uses original_line_price so it stays correct after the
   discount applies.
   ELIGIBLE_IDS must stay in sync with the discount's product list AND
   snippets/s7-discount-nudge.liquid + snippets/s7-pdp-badge.liquid. */
(function () {
  'use strict';
  var LIMIT = 10000; // $100 in cents
  var ELIGIBLE = {
    '8262050808116': 1, '8536402755892': 1, '9076884472116': 1, '9150131011892': 1,
    '9168188965172': 1, '9168191914292': 1, '9168897573172': 1, '9168901833012': 1,
    '9170602590516': 1
  };
  var lastAmt = null;

  function fmt(cents) { return '$' + (cents / 100).toFixed(2).replace(/\.00$/, ''); }

  function eligibleSubtotal(cart) {
    var sum = 0, items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      if (ELIGIBLE[String(items[i].product_id)]) sum += items[i].original_line_price;
    }
    return sum;
  }

  function paint(amt) {
    if (typeof amt !== 'number') return;
    lastAmt = amt;
    var nodes = document.querySelectorAll('[data-s7-disc]');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (amt > 0 && amt < LIMIT) {
        if (el.hidden) el.hidden = false;
        var r = el.querySelector('[data-s7-remain]');
        var txt = fmt(LIMIT - amt);
        if (r && r.textContent !== txt) r.textContent = txt;
        var f = el.querySelector('[data-s7-fill]');
        var w = Math.round(amt / LIMIT * 100) + '%';
        if (f && f.style.width !== w) f.style.width = w;
      } else if (!el.hidden) {
        el.hidden = true;
      }
    }
  }

  function refresh() {
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' }, credentials: 'same-origin' })
      .then(function (res) { return res.json(); })
      .then(function (cart) { paint(eligibleSubtotal(cart)); })
      .catch(function () {});
  }

  var t;
  function debouncedRefresh() { clearTimeout(t); t = setTimeout(refresh, 120); }

  var rx = /\/cart\/(add|change|update|clear)(\.js|\?|$)/;

  // 1) fetch-based cart mutations
  if (window.fetch) {
    var _f = window.fetch;
    window.fetch = function () {
      var p = _f.apply(this, arguments);
      try {
        var a = arguments[0];
        var u = (a && a.url) ? a.url : (typeof a === 'string' ? a : '');
        if (rx.test(u)) p.then(debouncedRefresh, function () {});
      } catch (e) {}
      return p;
    };
  }

  // 2) XHR-based cart mutations (jQuery.ajax etc.)
  var _o = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    try { if (typeof u === 'string' && rx.test(u)) this.addEventListener('load', debouncedRefresh); } catch (e) {}
    return _o.apply(this, arguments);
  };

  // 3) repaint when the drawer is injected/re-rendered (template clone / innerHTML)
  function nodeHasDisc(n) {
    return n.nodeType === 1 && ((n.matches && n.matches('[data-s7-disc]')) || (n.querySelector && n.querySelector('[data-s7-disc]')));
  }
  var mo = new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        if (nodeHasDisc(added[j])) {
          if (lastAmt != null) paint(lastAmt); // instant from cache
          refresh();                            // then sync exact value
          return;
        }
      }
    }
  });

  function start() {
    try { mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {}
    ['cart:updated', 'cart:refresh', 'cart:change', 'cart:build', 'ajaxProduct:added', 'theme:cart:change', 'on:cart:update']
      .forEach(function (ev) { document.addEventListener(ev, debouncedRefresh); });
    refresh(); // prime lastAmt + paint any nudge already present
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
